// extracted by mini-css-extract-plugin
export var infoRow = "_rw-2";
export var labelContainer = "_rw-0";
export var rightInfo = "_rw-1";